import React, { useEffect, useState } from 'react';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import { UserState } from '../../../store/reducers/userReducer';
import { RootState } from '../../../store/index';

import './index.css'
import LcDropDown from '../../Generic/LcDropDown';
import { InputField } from '../../../components/Form/Input';

//MSAL
import { authProvider } from '../../../services/authProvider';
import { CircularProgress, Grid } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useDebounce } from 'use-debounce';
import LcIconLink from '../../Generic/LcIconLink';
import LcLoading from '../../Generic/LcLoading';

interface Props {
    toggle: boolean;
}

const UserMenu: React.FC<Props> = (props) => {

    const user = useSelector<RootState, UserState>(state => state.user);
    const dispatch = useDispatch();
    const history = useHistory();
    const [filter, setFilter] = useState<string>();
    const [loadingCustomerChange, setLoadingCustomerChange] = useState<boolean>(false);
    const [companyList, setCompanyList] = useState<any[]>([]);
    const [filterDebounce] = useDebounce(filter, 500);

    const handleCompanyChange = (company: any) => {

        setLoadingCustomerChange(true);
        //   var companyLoadingTrick = { ...company };
        //companyLoadingTrick.clientGroupId = 0;
        // dispatch({ type: 'USER_COMPANY_CHANGE', payload: companyLoadingTrick });
        //o authProvider tem que ser feito oara renovar o header não adianta so fazer o front end não comentar por favor

        authProvider.Renew(company.clientGroupId)
            .then(response => {
                dispatch({ type: 'MENU_USER_VISIBLE', payload: false });
                setLoadingCustomerChange(false);
            });
    }

    useEffect(() => {

        dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });

        const allItems: any[] = [];

        //Default company
        // user.ClientGroupList &&
        //     user.ClientGroupList.filter((c: any) => c.defaultClientGroup).map((company: any, index: number) => {
        //         allItems.push(company);
        //     });

        // user.ClientGroupList &&
        //     user.ClientGroupList.filter((c: any) => !c.defaultClientGroup && (!filter || c.descricao.toLowerCase().indexOf(filter.toLowerCase()) >= 0)).map((company: any, index: number) => {
        //         allItems.push(company);
        //     })

        setCompanyList(allItems);

    }, [filterDebounce]);

    const ClearSubMenu = () => {

        dispatch({ type: 'MENU_SELECTED_UPDATE', payload: null });
        dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });
        // dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: null });
        // localStorage.setItem('HeyHo_LastMenuItem', '');
    }

    if (loadingCustomerChange) {

        return (
            <Grid container justifyContent="center" alignItems="center">
                <CircularProgress />
            </Grid>
        );

    }
    else {
        return (
            <div className={`usermenu${props.toggle ? ' toggle' : ''} scrollable-v`}>
                <div className="closemenu mobile-only">
                    <LcIconLink icon="ppi ppi-x" tooltip="Fechar" onClick={() => { dispatch({ type: 'MENU_USER_VISIBLE', payload: false }) }} />
                </div>
                <div className="title">
                    <div className="username"> {user.name} </div>
                    {
                        // user.ClientGroupList.length == 1 && <div className="link company">{user.ClientGroupSelectedDescription} </div>
                    }
                    {/* {      
                        user.ClientGroupList.length >= 2 &&
                        <LcDropDown hold={true} element={<div className="link company">{user.ClientGroupSelectedDescription} <i className="ppi ppi-chevron-down-alt" /></div>} >
                            <InputField name="companyFilter" onChange={(event: any) => setFilter(event.value)} icon="ppi ppi-search" type="text" disableAutocomplete={true} />
                            <div className="scrollable-v" style={{ width: '280px', height: '400px' }}>
                                {
                                    companyList && companyList.map((company: any, index: number) => {
                                        if (company.defaultClientGroup) {
                                            return (
                                                <div key={index}>
                                                    <span className={`item`} onClick={() => { handleCompanyChange(company) }}>{company.descricao}</span>
                                                    <hr />
                                                </div>
                                            )
                                        } else {
                                            return <span key={index} className="item" onClick={() => { handleCompanyChange(company) }}>{company.descricao}</span>
                                        }
                                    })
                                }
                                {
                                    companyList.length == 1 && <span className="item">Nenhum registro encontrado</span>
                                }
                            </div>
                        </LcDropDown>
                    } */}
                </div>

                <div className="items">
                    {/* <div className="item">Minha conta</div> */}
                    <hr />
                    {/* <hr />
                    <div className="item">Centros de custo</div>
                    <div className="item">Usuários do portal</div>
                    <div className="item">Perfil de acesso</div> */}
                    <hr />
                    <div className="item" onClick={() => authProvider.LogOutMSSO()}>Sair</div>
                </div>
            </div>
        );
    }
}

export default UserMenu;